import React from "react";

import ButtonsView from "./buttons-view";

const ButtonsContainer = () => {
  return <ButtonsView />;
};

export default ButtonsContainer;
